import AsyncButton from '../../../shared/Loading/AsyncButton';

const ResumeSection = (props) => {
  return (
    <aside className="lg:sticky lg:top-8 self-start bg-white p-4 shadow-sm sm:p-5 md:p-6">
      <h2 className="mb-4 text-2xl font-bold leading-tight text-gray-800 sm:text-3xl">
        ¡Bienvenido al
        <br />
        Programa de puntos!
      </h2>
      <div className="mb-4 h-px w-full bg-gray-300" />
      <p className="mb-3 text-sm text-gray-700 sm:text-base">
        Empieza a acumular puntos y canjear recompensas.
      </p>
      <p className="mb-6 text-sm leading-5 text-gray-500">
        Revisa los <strong>Términos y Condiciones</strong> del Programa de Puntos.
      </p>
      <div className="space-y-3">
        {props.isEditor && (
          <label className="block w-full cursor-pointer rounded-md px-4 py-3 text-center text-sm font-medium
            text-white transition border border-personalized bg-personalized hover:bg-white hover:text-personalized hover:border-personalized"
          >
            + Subir Términos y Condiciones
            <input
              type="file"
              accept=".pdf"
              className="hidden"
              onChange={(e) => {props.handleChangeFile(e)}}
            />
          </label>
        )}
        <AsyncButton
          type="button"
          onClick={props.handleViewTerms}
          className="block w-full cursor-pointer rounded-md px-4 py-3 text-center text-sm font-medium text-white transition
            border border-personalized bg-personalized hover:bg-white hover:text-personalized hover:border-personalized"
        >
          Ver Términos y Condiciones
        </AsyncButton>
        {props.canSeeProfile &&
          <button
            type="button"
            onClick={props.setProfilePoint}
            className="block w-full cursor-pointer rounded-md px-4 py-3 text-center text-sm font-medium text-white transition
              border border-personalized bg-personalized hover:bg-white hover:text-personalized hover:border-personalized"
          >
            Consultar mis puntos
          </button>
        }
      </div>
    </aside>
  );
};

export default ResumeSection;
